module.exports = __webpack_public_path__ + "media/images/USA-banner1-dd050a30776d8c5f32ff7ce731ad7d30.jpg";